<template>
<!-- TODO: Add app reset timeout back in -->
  <div id="app" @click="resetAppTimeout" v-if="isAppReady" :class="language.code">
    <transition name="fade">
      <router-view class="router-view"/>
    </transition>
    <transition name="slide-in-up">
      <bottom-bar class="bottom-bar" v-if="isBottomBarVisible"/>
    </transition>
    <!-- <touch-prompt></touch-prompt> -->
  </div>
</template>
<script>
import BottomBar from '@/components/BottomBar'
import _ from 'lodash'

// No change pls
const BASE_VIEWPORT_WIDTH = 1920
const BASE_VIEWPORT_HEIGHT = 1080
const BASE_FONT_SIZE = 10

export default {
  components: { BottomBar },

  data () {
    return {
      appTimeout: null
    }
  },

  computed: {
    isAppReady () {
      return this.$store.state.config && this.$store.state.pages && this.$store.state.navigation
    },

    isBottomBarVisible () {
      return this.$store.state.isBottomBarVisible
    },

    language () {
      return this.$store.getters.language
    }
  },

  methods: {
    // We use cookies to set some variables on a per browser level
    // For example - one touchscreen might need to trigger video wall videos
    // This touchscreen will load http://localhost?triggerVideos=true which will set the required variable
    // This is then set as a session cookie so even refreshing to http://localhost/#/ wont lose the settings    
    handleCookies () {
      if (typeof this.$route.query.triggerVideos !== 'undefined') { document.cookie = `triggerVideos=${this.$route.query.triggerVideos}` }
      const triggerVideos = document.cookie.replace(/(?:(?:^|.*;\s*)triggerVideos\s*=\s*([^;]*).*$)|^.*$/, '$1') == 'true' ? true : false
      if (typeof triggerVideos !== 'undefined') { this.$store.state.triggerVideos = triggerVideos }


      if (typeof this.$route.query.videoWallHost !== 'undefined') { document.cookie = `videoWallHost=${this.$route.query.videoWallHost}` }
      const videoWallHost = document.cookie.replace(/(?:(?:^|.*;\s*)videoWallHost\s*=\s*([^;]*).*$)|^.*$/, '$1')
      if (typeof videoWallHost !== 'undefined') {this.$store.state.videoWallHost = videoWallHost}   

      if (typeof this.$route.query.hideLiveHere !== 'undefined') { document.cookie = `hideLiveHere=${this.$route.query.hideLiveHere}`}
      const hideLiveHere = document.cookie.replace(/(?:(?:^|.*;\s*)hideLiveHere\s*=\s*([^;]*).*$)|^.*$/, '$1') == 'true' ? true : false
      if (typeof hideLiveHere !== 'undefined') { this.$store.state.hideLiveHere = hideLiveHere}

      if (typeof this.$route.query.deviceName !== 'undefined') { document.cookie = `deviceName=${this.$route.query.deviceName}`}
      const deviceName = document.cookie.replace(/(?:(?:^|.*;\s*)deviceName\s*=\s*([^;]*).*$)|^.*$/, '$1')
      if (typeof deviceName !== 'undefined') { this.$store.state.deviceName = deviceName }      
    },

    initSnitch () {
      // Snitch every minute
      setInterval(() => {
        this.$store.dispatch('snitch')
      }, 60 * 1000)
    },

    resetAppTimeout () {
      if (this.appTimeout) {
        clearInterval(this.appTimeout)
      }

      this.appTimeout = setInterval(() => {
        window.location.href = window.location.origin 
      }, 1000 * 300)
    },

    // Super important: The base font size is used to position and size everything using REM at different screen sizes
    setBaseFontSize () {
      const widthScale = window.innerWidth / BASE_VIEWPORT_WIDTH
      const heightScale = window.innerHeight / BASE_VIEWPORT_HEIGHT

      if (widthScale < heightScale) {
        this.$store.state.appScale = widthScale
      } else {
        this.$store.state.appScale = heightScale
      }

      document.documentElement.style.fontSize = `${this.$store.state.appScale * BASE_FONT_SIZE}px`
    },
  },

  async created () {
    await this.$store.dispatch('fetchData')
  },

  mounted () {
    this.handleCookies()
    this.resetAppTimeout()

    if (this.$store.state.deviceName) {
      this.initSnitch()
    }   

    // Debounce would probably be more performant but 🤷, throttle feels nicer
    window.addEventListener('resize', _.throttle(() => {
      this.setBaseFontSize()
    }, 100))
    this.setBaseFontSize()
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_animations.scss";
@import "@/styles/_type.scss";

@media (hover: none) {
  #app {
    cursor: none;
  }
}

html {
  background-color: #333;
  color: #fff;
  font-size: 62.5%;
  font-weight: 400;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

body {
  display: flex;
  height: 100vh;
  margin: 0;
}

#app {
  background-color: #000;
  height: 108rem;
  font-family: 'Nexa';
  margin: auto;
  overflow: hidden;
  position: relative;
  width: 192rem;

  &.ar {
    font-family: 'GE Dinkum';
  }
}

* {
  box-sizing: border-box;
  outline: none;
  // pointer-events: none;
  user-select: none;
}

.touch {
  pointer-events: auto;
}

a {
  color: $white;
  text-decoration: none;
}

p {
  margin-bottom: .6em;
  margin-top: 0;
}

button {
  border: none;
  background-color: transparent;
  color: $white;
  font-family: 'Nexa';
  letter-spacing: 0.05em;

  .ar & {
    font-family: 'GE Dinkum';
  }  
}

.main {
  height: 98rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 152rem;
}

.dir-rtl {
  direction: rtl;
  text-align: right !important;
}
</style>
